import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import Request from './ResetPassword/Request';
import Confirmation from './ResetPassword/Confirmation';
import Authenticate from './ResetPassword/Authenticate';
import PasswordChangeContextProvider from '@context/PasswordChangeProvider';

const ResetPassword = () => {
    const { path: matchPath } = useRouteMatch();

    return (
        <Switch>
            <Route path={matchPath} exact>
                <Request />
            </Route>

            <Route path={`${matchPath}/confirmation`} exact>
                <Confirmation />
            </Route>

            <Route path={`${matchPath}/authenticate`} exact>
                <PasswordChangeContextProvider>
                    <Authenticate />
                </PasswordChangeContextProvider>
            </Route>
        </Switch>
    );
};

export default ResetPassword;
